import { createContext } from "react";
import Keycloak, {
  KeycloakLoginOptions,
  KeycloakRegisterOptions,
} from "keycloak-js";
export interface IKeycloakContext {
  isAuthenticated: boolean;
  isAuthenticating: boolean;
  login?: (options?: KeycloakLoginOptions) => Promise<void>;
  logout?: (() => Promise<void>) | (() => void);
  register?: (options?: KeycloakRegisterOptions | undefined) => Promise<void>;
  name?: string;
  token?: string;
  roles?: string[];
  keycloak?: Keycloak;
  error?: string;
}

export const KeycloakContext = createContext<IKeycloakContext>({
  isAuthenticated: false,
  isAuthenticating: true,
});

export const KeycloakProvider = KeycloakContext.Provider;
